import { getFocusables } from '../lib-getFocusables';
// focus trap implemented in the following way
// when tab is pressed on the last focusable we catch it and move focus on the element
// element sees that shift isn't pressed and it moves focus to the first element
// when shift+tab is pressed on the first focusable we catch it and move the focus on the element
// element sees that shift is pressed and it moves focus to the last element
// then the default handler is triggered - it sees that the first element in focus order is focused
// and shift+tab is pressed and - it sees that the last element in focus order is focused
/**
 * Trap focus in the element
 * Returs function that removes all the listeners and removes focus trap
 */
export function focusTrap(el) {
    var shift = false; // focus event doesn't have event.shiftKey
    var ourFocus = false; // discern between event when it is triggered by el.focus() against event triggered by user click
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('keyup', onKeyUp);
    el.addEventListener('focus', onFocus);
    return function () {
        document.removeEventListener('keydown', onKeyDown);
        document.removeEventListener('keyup', onKeyUp);
        el.removeEventListener('focus', onFocus);
    };
    function onKeyDown(e) {
        if (e.key === 'Shift') {
            shift = true;
        }
        else if (e.key === 'Tab') {
            var activeElement = document.activeElement;
            var firstFocusable = getFocusables(el)[0];
            var lastFocusable = last(getFocusables(el));
            var goesToLastFocusable = activeElement === firstFocusable && shift;
            var goesToFirstFocusable = activeElement === lastFocusable && !shift;
            if (goesToLastFocusable || goesToFirstFocusable) {
                e.preventDefault();
                e.stopPropagation();
                ourFocus = true;
                if (goesToFirstFocusable)
                    firstFocusable.focus();
                if (goesToLastFocusable)
                    lastFocusable.focus();
            }
        }
    }
    function onKeyUp(e) {
        if (e.key === 'Shift') {
            shift = false;
        }
    }
    function onFocus() {
        if (ourFocus) {
            ourFocus = false;
            if (shift) {
                last(getFocusables(el)).focus();
            }
            else {
                getFocusables(el)[0].focus();
            }
        }
    }
}
function last(array) {
    return array[array.length - 1];
}
